import React from "react";
import { ScanLine } from "lucide-react";

// Wordmark lockup: scan-frame mark (matches the favicon/PWA icon) + "TollBill Extractor".
// Reused across the sidebar, mobile header, and login screen for a consistent brand.
const SIZES = {
  sm: { box: "h-8 w-8 rounded-lg", icon: "h-4 w-4", title: "text-[15px]", sub: "text-[11px]", gap: "gap-2" },
  md: { box: "h-9 w-9 rounded-xl", icon: "h-5 w-5", title: "text-[16px]", sub: "text-xs", gap: "gap-2.5" },
  lg: { box: "h-12 w-12 rounded-2xl", icon: "h-6 w-6", title: "text-2xl", sub: "text-[13px]", gap: "gap-3" },
};

export const Logo = ({ size = "md", showText = true, className = "", ...props }) => {
  const s = SIZES[size] || SIZES.md;
  return (
    <div className={`flex items-center ${s.gap} ${className}`} data-testid="app-logo" {...props}>
      <div
        className={`flex ${s.box} shrink-0 items-center justify-center bg-primary text-primary-foreground shadow-sm`}
        aria-hidden="true"
      >
        <ScanLine className={s.icon} />
      </div>
      {showText && (
        <div className="leading-none">
          <div className={`font-heading font-bold tracking-tight leading-none ${s.title}`}>TollBill</div>
          <div className={`font-medium leading-none mt-1 text-primary ${s.sub}`}>Extractor</div>
        </div>
      )}
    </div>
  );
};
